import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

export interface RestoreDeleteDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-restore-delete-dialog',
  template: `
    <div class="restore-dialog">
      <div class="restore-dialog-header" style="position: relative;">
        <h4>{{ data.title || 'XÁC NHẬN KHÔI PHỤC' }}</h4> 
      </div>
      <span class="btn-close" (click)="onClose()" style="position: absolute; right: 14px; top: 5px;">
          <i class="ti ti-x" style="color: #fff;"></i>
        </span>
      
      <div class="restore-dialog-body">
        <p>{{ data.message }}</p>
        
        <form [formGroup]="passwordForm">
          <div class="form-group">
            <label>Vui lòng nhập mật khẩu tài khoản để xác nhận <span class="text-danger">*</span></label>
            <input 
              type="password" 
              class="form-control mt-2" 
              formControlName="password"
              placeholder="Nhập mật khẩu"
            />
            <div *ngIf="submitted && passwordForm.controls['password'].errors" class="invalid-feedback d-block">
              <div *ngIf="passwordForm.controls['password'].errors['required']">Vui lòng nhập mật khẩu</div>
            </div>
          </div>
        </form>
      </div>
      
      <div class="restore-dialog-footer">
        <button class="btn btn-outline-secondary Btn__custom-cancel" (click)="onClose()">
            <i class="ti ti-xbox-x-filled icon__customAlert"></i>
            Hủy
        </button>
        <button class="btn btn-primary Btn__custom-save" (click)="onDelete()">
            <i class="ti ti-check icon__customAlert"></i>
            Lưu thông tin
        </button>
      </div>
    </div>
  `,
  styles: [`
    .restore-dialog {
      position: relative;
    }
    .restore-dialog-header {
      background-color: #dc3545;
      color: white;
      padding: 15px 20px;
      text-align: center;
    }
    .restore-dialog-header h4 {
      margin: 0;
      font-family: 'Roboto', sans-serif;
      font-weight: 600;
      font-size: 22px;
      text-transform: uppercase;
      color: #fff;
    }
    .btn-close {
      background: none;
      border: none;
      color: white;
      font-size: 20px;
      cursor: pointer;
    }
    .restore-dialog-body {
      padding: 20px;
    }
    .restore-dialog-body p {
      margin-bottom: 20px;
      text-align: center;
      font-family: 'Roboto', sans-serif;
      font-weight: 600;
      font-size: 18px;
    }
    .restore-dialog-footer {
      padding: 15px 20px;
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      border-top: 1px solid #e9ecef;
    }
    .btn-secondary {
      background-color: #f0f2f5;
      border: 1px solid #dee2e6;
      color: #333;
    }
    .btn-primary {
      background-color: #3f51b5;
      border: none;
      color: white;
    }
    .text-danger {
      color: #dc3545;
    }
    .invalid-feedback {
      color: #dc3545;
      font-size: 12px;
      margin-top: 4px;
    }
  `]
})
export class RestoreDeleteDialogComponent implements OnInit {
  passwordForm: FormGroup;
  submitted = false;

  constructor(
    public dialogRef: MatDialogRef<RestoreDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RestoreDeleteDialogData,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.passwordForm = this.fb.group({
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close(null);
  }

  onDelete(): void {
    this.submitted = true;
    
    if (this.passwordForm.invalid) {
      return;
    }
    // this.router.navigate(['/backup-restore/restore-list']);
    
    this.dialogRef.close({
      password: this.passwordForm.controls['password'].value
    });
  }
} 